/** Декор темы industrial: пять косых полосок от светло-жёлтого к оранжевому, как на слайдах. */
const STRIPES = ['bg-primary-100', 'bg-primary-300', 'bg-primary-500', 'bg-accent-300', 'bg-accent-400'];

export default function ThemeStripes({ className = '' }: { className?: string }) {
  return (
    <div className={`flex gap-1.5 ${className}`} aria-hidden="true">
      {STRIPES.map((bg) => (
        <span key={bg} className={`block h-3.5 w-6 -skew-x-[24deg] ${bg}`} />
      ))}
    </div>
  );
}
